import React from 'react';
import '../statusBar.css';
import LanguageSelect from "./LanguageSelect";
import Steps from "./Steps";
import {UserIcon} from "./User";
import Help from "./Help";
import CloseAppButton from "../CloseAppButton";
import {SwitchUser} from "./SwitchUser";

export default function () {
    return (
        <div>
            <div className={"statusBar"} style={{
                backgroundColor: "#3d94f6",
                color: '#FFF'
            }}>
                <LanguageSelect />
                <Help/>
                <Steps/>
                <CloseAppButton/>
                <UserIcon/>
                <SwitchUser/>
            </div>
        </div>
    );
}